const setupParallax = () => {
    if(document.querySelector('.stoof-parallax-wrapper')){
        window.addEventListener('scroll', throttle(parallax, 14));

        function throttle(fn, wait) {
            let time = Date.now();
            return function() {
                if ((time + wait - Date.now()) < 0) {
                    fn();
                    time = Date.now();
                }
            }
        };

        function parallax() {
            let scrolled = window.pageYOffset;
            let parallax = document.querySelectorAll('.stoof-parallax');
            if(parallax.length > 0){
                parallax.forEach(p => {

                    let parent = p.parentElement;
                    let parentRect = parent.getBoundingClientRect();
                    // You can adjust the 0.3 to change the speed
                    let coords = (scrolled * 0.3) + 'px';
                    if(parentRect.bottom > 0)
                    p.style.transform = 'translateY(' + coords + ')';
                })
            }

        };
    }
}
export  default setupParallax;